import { useState } from "react";
import { getBlindScanProgress } from "../../../actions/scanReportActions";
import { useDispatch } from "react-redux";
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import { Button, withStyles } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from "../../../reducers/uiSlice";

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: '100%',
        marginBottom: 20
    },
}))(TextField);

function SearchBatches() {
    const dispatch = useDispatch();
    const {t} = useTranslation('scanReport');
    
    const [blindBatches, setBlindBatches] = useState('');
    const [normalBatches, setNormalBatches] = useState('');

    const handleBlindBatches = (event) => {
        setBlindBatches(event.target.value.replace(/\s/g, ''));
    };
    const handleNormalBatches = (event) => {
        setNormalBatches(event.target.value.replace(/\s/g, ''));
    };

    function handleSubmit() {
        if(validateSubmit(blindBatches) && validateSubmit(normalBatches)) {
            if(!blindBatches || !normalBatches) {
                dispatch(showAlertSnackbar({message: t('error_message'), type: 'error'}))
            } else {
                dispatch(getBlindScanProgress(blindBatches, normalBatches))
            }
            
        } else {
            dispatch(showAlertSnackbar({message: t('validate_fail_message'), type: 'error'}))
        }        
    }
    function validateSubmit(batches) {
        let batchesCurr = batches.replace(/，/ig,',');
        var batchesRegex = /^[\.a-zA-Z0-9,-]*$/i;
        if(batchesRegex.test(batchesCurr)) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <FixedTextField
                placeholder={t('input_blind')}
                onChange={handleBlindBatches}
                variant="outlined"
            />           
            <FixedTextField
                placeholder={t('input')}
                onChange={handleNormalBatches}
                variant="outlined"
            />
            <Button 
                variant="contained" 
                color="primary"
                style={{ width: 100, marginLeft: 'auto', marginRight: 'auto' }}
                onClick={handleSubmit}
            >
                {t('submit')}
            </Button>
        </div>
    );
}

export default SearchBatches;